// extracted by mini-css-extract-plugin
module.exports =  {"priceMovementChartRoot":"PriceMovementChart-module__priceMovementChartRoot--vMg94"};